const joinList = (items) => {
  if (items.length > 2) {
    return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
  }
  if (items.length === 2) {
    return items.join(' and ');
  }

  return items[0];
};

export const generateSuccessMessage = ({ recipients, whatShared, groupNamesShared }) => {
  if (whatShared === 'entire-project') {
    return `You've successfully shared your entire project with ${joinList(recipients)}.`;
  }
  return `You've successfully shared the ${joinList(groupNamesShared)} group(s) with ${joinList(recipients)}.`;
};

export const generateFailureMessage = ({ recipients }) => {
  if (recipients.length === 0) {
    return 'We\'re unable to share your project. Please try again';
  }
  return `We're unable to share your project with ${joinList(recipients)}. Please try again`;
};

export const getSuccessRecipients = (createShareContext) => {
  const recipients = [];
  createShareContext.forEach((element) => {
    if (element?.recipient) {
      recipients.push(element.recipient);
    }
  });
  return recipients;
};

export const getFailedRecipients = (errors) => {
  const recipients = [];
  const message = 'project sharing failed with: ';
  errors.forEach((error) => {
    if (error?.message.toLowerCase().includes(message)) {
      const [_, recipient] = error?.message.split(':');
      recipients.push(recipient.trim());
    }
  });
  return recipients;
};